












import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import HtmlEditor from "@/components/common/TinyMceEditor.vue";
// types
import { HtmlPostProperties } from "@/services/posts/postTypes/html";
import { ContentTemplate } from "@/services/contentTemplates/types";
import { ChannelStyle } from "@/services/channels/types";
// service methods
import { getChannelStyle } from "@/services/channels/channelsService";
import { getContentTemplate } from "@/services/contentTemplates/contentTemplateService";

@Component({
    components: {
        HtmlEditor
    }
})
export default class HtmlForm extends Vue {
    @Prop() private properties!: HtmlPostProperties;
    @Prop() private channelId!: string;
    @Prop() private contentTemplateId!: string;
    // local state
    localProperties = { html: "" } as HtmlPostProperties;
    channelStyleInfo: ChannelStyle | {} = {};
    contentTemplate = {} as ContentTemplate;
    render = false;
    // lifecycle hooks
    mounted() {
        getChannelStyle(this.channelId, "html").then(response => {
            this.channelStyleInfo = response;
            this.render = true;
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        });
        if (this.contentTemplateId) {
            getContentTemplate(this.contentTemplateId).then(response => {
                this.contentTemplate = response;
                this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
            });
        }

        if (this.properties.html && this.properties.html.length > 0) {
            this.localProperties = this.properties;
        }
        if (!this.localProperties.html) {
            this.localProperties.html = "";
        }
        this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
    }

    // watchers
    @Watch("contentTemplate")
    onContentTemplateChanged() {
        this.localProperties.html = this.contentTemplate.content.html;
        this.$nextTick(() => {
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        });
    }

    // methods

    onContentUpdated(data: any) {
        const contentComponentData = JSON.parse(data);
        this.localProperties.html = contentComponentData.html;
    }

    // events
    contentTemplateSelected() {
        if (this.contentTemplate) {
            this.localProperties.html = this.contentTemplate.content.html;
        }
    }

    onBlur(html: string) {
        this.setItemName(html);
    }

    onToggleHeaderButtons(state: boolean) {
        this.$emit("toggleHeaderButtons", state);
    }

    emitData() {
        const component = this.$refs.htmlEditor as any;
        if (component) {
            component.emitData();
        }
        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName(html: string) {
        var name = this.contentTemplate.name || html.split("</")[0].replace(/<\/?[^>]+(>|$)/g, "");

        // Create a textarea and retrieve the information from there. This will automatically convert HTML based entities to real characters, such as a &oslash; -> ø
        // While also being safe against XSS attacks
        const decodeElement = document.createElement("textarea");
        decodeElement.innerHTML = name;
        const decodedValue = decodeElement.value.trim(); // Trim spaces and newlines

        if (decodedValue) {
            this.$emit("itemNameUpdated", decodedValue);
        }
    }
}
